/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module alignment
 */
export { default as Alignment } from './alignment.js';
export { default as AlignmentEditing } from './alignmentediting.js';
export { default as AlignmentUI } from './alignmentui.js';
import './augmentation.js';
